// extracted by mini-css-extract-plugin
export default {"root":"n9_g6T_CPdmte6jED0rO"};